/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class NavigationAccordionDirectiveController {

        public static $inject : string[] = [
            '$mobilityUid',
            '$rootScope',
            '$mobilityWindow',
            '$timeout'
        ];

        public accordionNavigationId: string;
        public el: any;
        public showSubNavigation: boolean;
        public pages: any[];
        public pageLoading: boolean;
        public windowSizeSM: boolean;
        public windowSizeMD: boolean;
        public windowSizeLG: boolean;
        public windowSizeXL: boolean;

        constructor(public $mobilityUid: any,
                    public $rootScope: any,
                    public $mobilityWindow: any,
                    public $timeout: any) {
            this.pages = new Array();
            this.setWindowSize();
            this.$rootScope.$on('mobility_window_resized', () => {
                this.onMobilityWindowResize();
            });
        }

        public setWindowSize() : void {
            this.$timeout(() => {
                this.windowSizeSM = this.$mobilityWindow.isWindowSM();
                this.windowSizeMD = this.$mobilityWindow.isWindowMD();
                this.windowSizeLG = this.$mobilityWindow.isWindowLG();
                this.windowSizeXL = this.$mobilityWindow.isWindowXL();

            },0);
        }

        public generateAccordionNavigationId() : void {
            this.accordionNavigationId = this.$mobilityUid.generate();
        }

        public onMobilityWindowResize() : void {
            this.setWindowSize();
            if (!this.isPageShown()) {
                if (this.$mobilityWindow.isWindowSM()) {
                    angular.forEach(this.pages, (val : any) => {
                        if (val.isDefaultMobile) {
                            val.showPage();
                            return false;
                        }
                    })
                }
            }
        }

        public showDefaultPage() : void {
            angular.forEach(this.pages, (page : any,idx : any) => {
                var _default : boolean = false;

                if (this.$mobilityWindow.isWindowSM() && (page.isDefaultSm || page.isDefaultMobile) ) {
                    _default = true;
                }

                if (this.$mobilityWindow.isWindowMD() && (page.isDefaultMd || page.isDefault)) {
                    _default = true;
                }

                if (this.$mobilityWindow.isWindowLG() && (page.isDefaultLg || page.isDefault)) {
                    _default = true;
                }

                if (this.$mobilityWindow.isWindowXL() && (page.isDefaultXl || page.isDefault)) {
                    _default = true;
                }

                if (_default) {
                    page.showPage();
                } else {
                    page.hidePage();
                }
            });
        }

        public addPage(page : any) {
            this.pages.push(page);
        }

        public isPageShown() {
            var _isShown : boolean = false;
            angular.forEach(this.pages, (page,idx) => {
                if (page.isOpen) {
                    _isShown = true;
                    return false;
                }
            });
            return _isShown;
        }

        public hideOtherPages(page : any) {
            angular.forEach(this.pages, (p,idx) => {
                if (!( p === page)) {
                    p.hidePage();
                }
            });
        }

        public showPage(page : any) {
            if (!this.pageLoading) {
                page.showPage();
            }
        }

        public hidePage(page : any) {
            page.hidePage();
        }

        public closeAll() {
            angular.forEach(this.pages, (page,idx) => {
                page.hidePage();
            });
        }
    }

    getDealerwareWebComponentsModule().controller('NavigationAccordionDirectiveController', NavigationAccordionDirectiveController);

    export class NavigationAccordion implements ng.IDirective {
        public restrict         : string    =   'EA';
        public controller       : any       =   'NavigationAccordionDirectiveController';
        public controllerAs     : string    =   'ctrl';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   { pageTitle: '=', pageName: '=', showSubNavigation: '=?'};
        public transclude       : boolean   =   true;
        public templateUrl      : any       =   function(element : any,attributes : any ) : any { return attributes.template || '/components/navigation/accordion/navigation_accordion_directive.html';};
        public static $inject   : string[]  =   ['$mobilityUid'];

        constructor(public $mobilityUid : any) {}

        public link : ng.IDirectivePrePost = {
            pre: function(scope : any,element : any,attrs : any,ctrl : any) {
                // get the wizard id or create one
                if (attrs && angular.isObject(attrs) && attrs.hasOwnProperty('id')) {
                    ctrl.accordionNavigationId = attrs.id;
                } else {
                    ctrl.generateAccordionNavigationId();
                }
                ctrl.el = element;
            },
            post: function(scope,element,attrs) {
            }
        }

        static factory(): ng.IDirectiveFactory {
            const directive = ($mobilityUid: any) => new NavigationAccordion($mobilityUid);
            return directive;
        }

    }

    getDealerwareWebComponentsModule().directive("navigationAccordion", NavigationAccordion.factory());
}
